module.exports = __webpack_public_path__ + "img/service-icon-1.648fd1af.png";